import component from './ErrorPage.vue'
export default component
